// src/Utils.ts
export type UserRole = 'anonymous' | 'user' | 'admin';

const ACCESS_TOKEN_KEY = 'authToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const ROLE_KEY = 'userRole';

export const getAuthToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || sessionStorage.getItem(ACCESS_TOKEN_KEY);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY) || sessionStorage.getItem(REFRESH_TOKEN_KEY);
};

export const setAuthTokens = (accessToken: string, refreshToken: string | null): void => {
  const storage = localStorage.getItem('rememberMe') === 'true' ? localStorage : sessionStorage;
  storage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    storage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const setAuth = (
  accessToken: string,
  refreshToken: string | null,
  role: string,
  rememberMe: boolean
): void => {
  const storage = rememberMe ? localStorage : sessionStorage;
  storage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    storage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
  storage.setItem(ROLE_KEY, role);
  if (rememberMe) {
    localStorage.setItem('rememberMe', 'true');
  }
};

export const clearAuth = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem('rememberMe');
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  sessionStorage.removeItem(ROLE_KEY);
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

export const getUserRole = (): UserRole => {
  if (!isAuthenticated()) {
    return 'anonymous';
  }
  const role = localStorage.getItem(ROLE_KEY) || sessionStorage.getItem(ROLE_KEY);
  if (role === 'admin') {
    return 'admin';
  }
  return 'user';
};

export const getTranslations = async (language: string): Promise<Record<string, string>> => {
  try {
    const translations = await import(`./resources/lang/message_${language}.json`);
    return translations.default;
  } catch (error) {
    console.error(`Error loading translations for language: ${language}`, error);
    return {};
  }
};